export default __webpack_public_path__ + "static/24934223-day-b27423417e86f3856950b0b3b0582dda.webm";